import { render, staticRenderFns } from "./ContactChat.vue?vue&type=template&id=295e2d4c&lang=pug"
import script from "./ContactChat.vue?vue&type=script&lang=js"
export * from "./ContactChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports